import { defineStore } from "pinia";
import _ from "lodash";
import {
    FetchState,
    ManagedExpenseInitialState,
    ManagedExpensePagedResponse
} from "@/shared/types";
import * as expenseService from "@/shared/api/expenseService";
import * as storeHelper from "@/shared/storeHelper";
import Vue from "vue";

export const initialState: ManagedExpenseInitialState = {
    currentPage: {
        fetchState: FetchState.Uninitialized,
        page: 1,
        pageSize: 10,
        totalRecords: 0,
        numberOfPages: null,
        records: [],
    }
};

export const useManagedExpenseStore = defineStore("managedExpense", {
    state: (): ManagedExpenseInitialState => (_.cloneDeep(initialState)),
    getters: {
        isCurrentPageLoaded: state => state.currentPage.fetchState === FetchState.Loaded,
        isCurrentPageLoading: state => state.currentPage.fetchState === FetchState.Loading,
        currentPageItems: state => state.currentPage.records,
        currentPageNumber: state => state.currentPage.page,
        totalItemCount: state => state.currentPage.totalRecords,
        totalPageCount: state => state.currentPage.numberOfPages !== null ? state.currentPage.numberOfPages : 0,
    },
    actions: {
        overwriteRecordsForPage (response: ManagedExpensePagedResponse) {
            // overwrite the existing records in the array so that the UI does not jump
            // from 10 records to 0 and back to 10 when paging

            for (let index = 0; index < this.currentPage.pageSize; index++) {
                if (index < response.records.length) {
                    Vue.set(this.currentPage.records, index, response.records[index]);
                } else {
                    Vue.delete(this.currentPage.records, index);
                }
            }
        },
        loadManagedExpensesByPage (page: number) {
            if (this.currentPage.fetchState === FetchState.Loading) {
                return Promise.resolve();
            }

            this.currentPage.fetchState = FetchState.Loading;

            return expenseService.getManagedExpensesPage(page, this.currentPage.pageSize)
                .then(response => {
                    this.currentPage.page = page;
                    this.currentPage.totalRecords = response.data.totalRecords;
                    this.currentPage.numberOfPages = response.data.numberOfPages;
                    this.overwriteRecordsForPage(response.data);
                    this.currentPage.fetchState = FetchState.Loaded;
                })
                .catch(err => {
                    this.currentPage.fetchState = FetchState.Failed;
                    storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});